<template>
  <div class="site-class">
    <ContentClassCard
      v-for="item in max ? data?.slice(0, max) : data"
      :key="item.id"
      :url="item.cover_url"
      :isNew="item.is_new"
      :video="item.hover_video"
      target="_blank"
      :link="{
        name: PageKey.TUTORIAL_INFO,
        params: { id: item.jump_id },
      }"
      class="cursor-pointer"
      @click="onCoverClick(item)"
    >
    </ContentClassCard>
  </div>
</template>

<script lang="ts" setup>
import type { ClassSearchData } from '~/api/interface/search'
import { PageKey } from '~/constants/page'

defineProps<{
  data: ClassSearchData[]
  max?: number
}>()

const handleTracker = (record: ClassSearchData) => {
  trackEvent(TRACK_EVENT.CLICK_TUTORIAL_PLAY, {
    tutorial_id: record.id,
    source: SOURCE.Tutorial,
    position: '全站搜索页',
  })
}

const onCoverClick = (record: ClassSearchData) => {
  handleTracker(record)
}
</script>

<style lang="scss" scoped>
.site-class {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 162px;
  grid-auto-flow: dense;
  gap: 16px;
  // :deep(.card-item) {
  //   .description {
  //     display: none;
  //   }
  //   &:hover {
  //     .name {
  //       display: none;
  //     }
  //     .description {
  //       display: block;
  //     }
  //   }
  //   .avatar {
  //     @apply w-[16px] h-[16px] rounded-[50%];
  //     border: 1px solid var(--back-3);
  //   }

  //   .card {
  //     box-sizing: content-box;
  //     background-color: var(--back-1);
  //     height: 100%;
  //   }
  // }
}
</style>
